import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { noop } from 'lodash'
import { Button, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import { SyncAlt } from '@mui/icons-material'
import { dateTimeFormatter } from 'utils/data-manipulation/valueFormatter'
import { ERP_PROVIDERS } from 'utils/constants'

const ActionBar = ({ onSync, isLoading, allowSync, lastSyncDate, erpProvider, onMarkAsSynced }) => {
  const { canMarkAsSynced } = useSelector(state => state.featureFlags?.variables || {})
  const erpProviderName = ERP_PROVIDERS[erpProvider]?.name || ''
  const getSyncDate = () =>
    lastSyncDate ? `Last synced on ${dateTimeFormatter(lastSyncDate, { dateFormatFull: true })}` : ''

  return (
    <>
      <Divider />
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" py={2}>
        <Grid item py={1}>
          <Button
            variant="contained"
            size="small"
            disabled={isLoading || !allowSync}
            startIcon={isLoading ? <CircularProgress color="borderColor" size={18} /> : <SyncAlt />}
            onClick={onSync}
          >
            Sync
          </Button>
        </Grid>
        {canMarkAsSynced && (
          <Grid item py={1} pl={3}>
            <Button variant="text" size="small" disabled={isLoading || !allowSync} onClick={onMarkAsSynced}>
              Mark as Synced
            </Button>
          </Grid>
        )}
        <Grid>
          <Typography variant="body1" px={2}>
            {isLoading ? `Syncing to ${erpProviderName}...` : getSyncDate()}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

ActionBar.propTypes = {
  onSync: PropTypes.func,
  isLoading: PropTypes.bool,
  allowSync: PropTypes.bool,
  lastSyncDate: PropTypes.string,
  erpProvider: PropTypes.string,
  onMarkAsSynced: PropTypes.func.isRequired,
}

ActionBar.defaultProps = {
  onSync: noop,
  isLoading: false,
  allowSync: false,
  lastSyncDate: '',
  erpProvider: '',
}

export default ActionBar
